module.exports = __webpack_public_path__ + "static/media/estados-unidos.810d59c0.png";